// services/lawyerService.js

const API_URL = process.env.REACT_APP_API_URL;

export const lawyerService = {
  // Fetch all lawyer details 
  async getLawyerDetails() {
    try {
      const response = await fetch(`${API_URL}/api/law_firm/lawyer_details`);

      if (!response.ok) {
        throw new Error('Failed to fetch lawyer details');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching lawyer details:', error);
      throw error;
    }
  },

  
};